<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-17 15:58:50
 * @LastEditors: xgx
 * @LastEditTime: 2023-06-08 10:47:10
-->
<template>
   <div>
       <div class="top">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="机器人设置" name="first"></el-tab-pane>
            <el-tab-pane  v-if="codeData.indexOf('66') != -1" label="热门主题" name="second"></el-tab-pane>
            <el-tab-pane  v-if="codeData.indexOf('67') != -1" label="常见问题" name="third"></el-tab-pane>
          </el-tabs>
       </div>
       <RobotSetting v-if="type == 1"/>
       <HotTopics v-if="type == 2"/>
       <ChangJan v-if="type == 3"/>
   </div>
</template>

<script>
import RobotSetting from './components/RobotSettings';
import HotTopics from './components/HotTopics';
import ChangJan from './components/ChangJan';
export default {
   data(){
      return {
          type:1,
          codeData:[],
          activeName:'first',
      }
   },
   components:{
      RobotSetting,
      HotTopics,
      ChangJan
   },
   mounted(){
      this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
   },
   methods:{
      changeType(type){
            this.type = type;
      },
       handleClick(){
        if(this.activeName == 'first'){
            this.type = 1;
            this.changeType(1)
        }
         if(this.activeName == 'second'){
            this.type = 2;
            this.changeType(2)
        }
         if(this.activeName == 'third'){
            this.type = 3;
            this.changeType(3)
        }
      }
   }
}
</script>

<style lang="less" scoped>
.top{
   padding: 24px;
   padding-bottom: 0px;
}
   .log-box {
    border-bottom: solid 1px #dcdfe6;
    display: flex;
    color: #000;
    .log {
      padding: 10px 20px;
      border-top: solid 1px #dcdfe6;
      border-left: solid 1px #dcdfe6;
      cursor: pointer;
    }
    .log:last-child {
      border-right: solid 1px #dcdfe6;
      border-top-right-radius: 10px;
    }
    .log:first-child {
      border-top-left-radius: 10px;
    }
  }
  /deep/ .el-tabs__header{
    margin: 0px;
  }
</style>